module.exports = __webpack_public_path__ + "static/media/azuredevops.d5a77b0f.png";